import { Box, Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { addFile } from "../productGroupSetupSlice";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { useRef } from "react";

export default function CreateFileUpload() {
	const inputRef = useRef(null);
	const dispatch = useDispatch();

	function handleInputClick() {
		inputRef.current.click();
	}

	function uploadFile(event) {
      for(let i = 0; i < event.target.files.length; ++i) {
         const file = event.target.files[i];
         console.log(file);
         dispatch(addFile(file));
      }
	}

	return (
		<Box>
			<input hidden type="file" multiple={true} ref={inputRef} onChange={uploadFile} />

			<Button
				startIcon={<AttachmentIcon />}
				sx={{
					bgcolor: "blue.main",
					color: "white.main",
					textTransform: "none",
					fontWeight: "bold",
					"&:hover": {
						bgcolor: "skyBlue.main",
						color: "black.main",
					},
					marginLeft: "calc(100% - 155px)"
				}}
				onClick={handleInputClick}
			>
				Attach File
			</Button>
		</Box>
	);
}
